import { render, staticRenderFns } from "./DisplayBoolean.vue?vue&type=template&id=3be37e4a&"
import script from "./DisplayBoolean.vue?vue&type=script&lang=js&"
export * from "./DisplayBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DisplayBoolean.vue"
export default component.exports